<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <div>
            <LoadCustom ref="loadCustom"></LoadCustom>
        </div>

        <div v-if="!pdfUrl" class="text-center text-secondary my-2 align-items-center">
            <b-spinner class="align-middle me-2"></b-spinner>
            <strong>Obteniendo enlace del documento...</strong>
        </div>

        <div class="pdf-container d-flex flex-column align-items-center">
            <canvas
                v-for="(page, index) in pages"
                :key="index" ref="canvas"
                class="pdf-page mb-2"
            />
        </div>
    </div>
</template>
<script>
import { pdfjsLib } from '@/plugins/PDF/index';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import LoadCustom from '@/components/shared/Load-custom.vue'

export default {
    name: 'DocumentPdf',

    props: {
        pdfUrl: {
            type: String,
            required: true
        }
    },

    components: {
        AlertDismiss,
        LoadCustom
    },

    data() {
        return {
            pages: []
        };
    },

    async mounted() {
        await this.processPdfUrl(this.pdfUrl);
    },

    methods: {
        async processPdfUrl(urlToLoad) {
            this.pages = []; // Reset pages

            if (urlToLoad == null || urlToLoad.trim() === '') {
                this.$emit('pdf-load-error');
                return;
            }

            if (!await this.loadPDF(urlToLoad)) {
                return;
            }

            if (!await this.renderPages()) {
                return;
            }

            this.$emit('pdf-load-success');
        },

        async loadPDF(url) {
            try {
                this.$refs.loadCustom.load('Cargando pdf...', true);

                if (url == null || url.trim() === '') {
                    this.$emit('pdf-load-error');
                    this.$refs.loadCustom.load('', false);
                    return false;
                }

                const loadingTask = pdfjsLib.getDocument(url);
                const pdf = await loadingTask.promise;

                const totalPages = pdf.numPages;

                for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
                    const page = await pdf.getPage(pageNumber);
                    this.pages.push(page);
                }

                this.$refs.loadCustom.load('', false);
                return true;
            }
            catch (error) {
                this.$refs.loadCustom.load('', false);
                this.$refs.alertDismiss.showAlert('Ocurrio un error al intentar cargar el documento.');
                this.$emit('pdf-load-error');
                return false;
            }
        },

        async renderPages() {
            try {
                this.$refs.loadCustom.load('Mostrando pdf...', true);

                const canvasElements = this.$refs.canvas;

                for (let i = 0; i < this.pages.length; i++) {
                    const canvas = canvasElements[i];
                    const page = this.pages[i];
                    const viewport = page.getViewport({ scale: 1.2 });
                    const context = canvas.getContext('2d');

                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await page.render({ canvasContext: context, viewport: viewport }).promise;
                }
                this.$refs.loadCustom.load('', false);
                return true;
            }
            catch (error) {
                this.$refs.loadCustom.load('', false);
                this.$refs.alertDismiss.showAlert('Ups! error al momento de mostrar el pdf.');
                this.$emit('pdf-load-error');
                return false;
            }
        }
    },

    watch: {
        async pdfUrl(newUrl, oldUrl) {
            if (newUrl === oldUrl) {
                return;
            }
            await this.processPdfUrl(newUrl);
        }
    }
}
</script>
<style scoped>
.pdf-page {
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease-in-out;
}

.pdf-page:hover {
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.2);
}
</style>